<template>
    <div class="mvt-saleproceeds">
        <div class="header-layout large fixed fixed-max-sm" :class="{'intro':$slots.intro}">
            <div class="grid xs-grid-cols-1 one" v-if="$slots.intro">
                <slot name="intro"></slot>
            </div>

            <div class="net-proceeds-info two">
                    <div class="text-center net-proceeds-header">
                        <div class="f6 title text-bold">ESTIMATED NET PROCEEDS</div>
                        <h2 class="f1 value text-bold">{{ $filters.formatPrice(netProceeds) }}</h2>
                    </div>
                    <div class="net-procceds-footer">
                        <div class="flex">
                            <div class="title">Home Sale Price </div>
                            <div class="value text-bold">{{ $filters.formatPrice(getPrice) }}</div>
                        </div> <hr>
                        <div class="flex">
                            <div class="title">Outstanding Mortgage </div>
                            <div class="value text-bold">{{ $filters.formatPrice(mortgage) }}</div>
                        </div> <hr>
                        <div class="flex">
                            <div class="title">Fees & Misc. Costs </div>
                            <div class="value text-bold">{{ $filters.formatPrice(totalCosts) }}</div>
                        </div>
                    </div>
            </div>

            <div class="bg-default inline corner border three">
                <mvtCollapse :disable="true">
                    <template v-slot:header="collapsible">
                        <div class="f5">Home Sale</div>
                    </template>
                    <template v-slot:default>
                        <form novalidate class="form grid xs-grid-cols-1">
                            <div class="group">
                                <mvtTextbox>
                                    <div class="input right">
                                        <label>Home Sale Price</label>
                                        <mvtInputNumber @input="updateFeesBasedPerc" v-model="price" :prefix="'$'"/>
                                        <a class="link f6" @click="openLead">Get free valuation</a>
                                    </div>
                                </mvtTextbox>
                            </div>
                            <div class="group">
                                <mvtTextbox>
                                    <div class="input">
                                        <label>Outstanding Mortgage</label>
                                        <mvtInputNumber v-model="mortgage" :prefix="'$'"/>
                                    </div>
                                </mvtTextbox>
                            </div>
                        </form>
                    </template>
                </mvtCollapse>
            </div>
        </div>
        <div class="grid gap-3 fixed fixed-max-sm top xs-grid-cols-1 m-t-2" :class="{'sm-grid-cols-2': $slots.sidecard}">
            <div class="grid xs-grid-cols-1">
                <div class="bg-default inline corner border">
                    <mvtCollapse :isActive="true">
                        <template v-slot:header="collapsible">
                            <div class="flex">
                                <div class="f5">Closing Fees</div>
                                <div class="m-r-4" v-if="netClosingFee">{{ $filters.formatPrice(netClosingFee) }}</div>
                            </div>
                        </template>
                        <template v-slot:default>
                            <form novalidate class="form grid xs-grid-cols-1">
                                <div class="group in-line">
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Agent Fee</label>
                                            <mvtInputNumber @input="updateAgentPerc" v-model="agentFee" :prefix="'$'"/>
                                        </div>
                                    </mvtTextbox>
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Percent</label>
                                            <mvtInputDecimalNumber @input="updateAgentFee" v-model="agentPercent" :suffix="'%'" :maxDecimalPlaces="2"/>
                                        </div>
                                    </mvtTextbox>
                                </div>

                                <div class="group in-line">
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Closing Costs</label>
                                            <mvtInputNumber @input="updateClosingPerc" v-model="closingCosts" :prefix="'$'"/>
                                        </div>
                                    </mvtTextbox>
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Percent</label>
                                            <mvtInputDecimalNumber @input="updateClosingCosts" v-model="closingPercent" :suffix="'%'" :maxDecimalPlaces="2"/>
                                        </div>
                                    </mvtTextbox>
                                </div>

                                <div class="group in-line">
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Seller Concessions</label>
                                            <mvtInputNumber @input="updateConcessionPerc" v-model="concessionFee"  :prefix="'$'"/>
                                        </div>
                                    </mvtTextbox>
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Percent</label>
                                            <mvtInputDecimalNumber @input="updateConcessionFee" v-model="concessionPercent" :suffix="'%'" :maxDecimalPlaces="2"/>
                                        </div>
                                    </mvtTextbox>
                                </div>
                            </form>
                        </template>
                    </mvtCollapse>
                </div>

                <div class="bg-default inline corner border">
                    <mvtCollapse :isActive="true">
                        <template v-slot:header="collapsible">
                            <div class="flex">
                                <div class="f5">Misc. Costs</div>
                                <div class="m-r-4" v-if="netMiscCosts">{{ $filters.formatPrice(netMiscCosts) }}</div>
                            </div>
                        </template>
                        <template v-slot:default>
                            <form novalidate class="form grid xs-grid-cols-1">
                                <div class="group in-line">
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Home Prep & Repairs</label>
                                            <mvtInputNumber @input="updateHomePrepPerc" v-model="homePrepFee" :prefix="'$'"/>
                                        </div>
                                    </mvtTextbox>
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Percent</label>
                                            <mvtInputDecimalNumber @input="updateHomePrepFee" v-model="homeprepPercent" :suffix="'%'" :maxDecimalPlaces="2"/>
                                        </div>
                                    </mvtTextbox>
                                </div>

                                <div class="group in-line">
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Moving & Short-Term Storage</label>
                                            <mvtInputNumber @input="updateStoragePerc" v-model="storageFee"   :prefix="'$'"/>
                                        </div>
                                    </mvtTextbox>
                                    <mvtTextbox>
                                        <div class="input">
                                            <label>Percent</label>
                                            <mvtInputDecimalNumber @input="updateStorageFee" v-model="storagePercent" :suffix="'%'"  :maxDecimalPlaces="2"/>
                                        </div>
                                    </mvtTextbox>
                                </div>
                            </form>
                        </template>
                    </mvtCollapse>
                </div>
            </div>
            <div class="grid xs-grid-cols-1" v-if="$slots.sidecard">
                <slot name="sidecard" :openLead="openLead" ></slot>
            </div>

        </div>
    </div>
</template>

<script src="./mvt-saleproceeds.js"></script>

<style lang="scss">
@use "./mvt-saleproceeds.scss" as *;
</style>
